module.exports = __webpack_public_path__ + "static/media/table-icon.6d2dd8d5.svg";